module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel05_770_280_th-0e0e85ba7bdb9d8c13382c36a8e9a07c.jpg";